import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'atrius-action-content',
  template: `
    <div>
      <ng-content></ng-content>
    </div>
    <div class="action-divider"></div>
  `,
  styleUrls: ['./action-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActionContentComponent {}
